import BaseRepository from "./BaseRepository";

export default new (class ProductScheduleSlotPricingsRepository extends BaseRepository {
  bulkUpdate(slots, pricings) {
    const body = {
      product_schedule_slots_attributes: slots,
      product_schedule_slot_pricings_attributes: pricings,
    };
    return this.api.post(`product_schedule_slot_pricings/bulk_update`, body);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/ProductScheduleSlotPricingsRepository.js